import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/RecruitInfo.module.css';
import WireframeBackground from '../components/WireframeBackground';

function RecruitInfo() {
    return (
        <div className={styles.container}>
            <WireframeBackground />
            <div className={styles.wrap}>
                <section className={styles.recruitSection}>
                    <div className={styles.header}>
                        <h1 className={styles.sectionTitle}>CAREER</h1>
                        <p className={styles.subtitle}>中途採用・新卒採用</p>
                    </div>

                    <div className={styles.content}>
                        {/* リギングアーティスト / テクニカルアーティスト セクション */}
                        <div className={styles.infoCard} id="artists">
                            <div className={styles.cornerTL}></div>
                            <div className={styles.cornerTR}></div>
                            <div className={styles.cornerBL}></div>
                            <div className={styles.cornerBR}></div>

                            <h2 className={styles.cardTitle}>リギングアーティスト / テクニカルアーティスト</h2>
                            <table className={styles.recruitTable}>
                                <tbody>
                                    <tr>
                                        <th>募集職種</th>
                                        <td>リギングアーティスト<br />テクニカルアーティスト</td>
                                    </tr>
                                    <tr>
                                        <th>雇用形態</th>
                                        <td>契約社員（正社員登用あり）</td>
                                    </tr>
                                    <tr>
                                        <th>報酬 / 給与</th>
                                        <td>
                                            応募者の能力・経験を考慮し、当社規定により決定いたします。
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>賞与</th>
                                        <td>年1回（ただし、業績による）</td>
                                    </tr>
                                    <tr>
                                        <th>昇給</th>
                                        <td>年1回</td>
                                    </tr>
                                    <tr>
                                        <th>業務内容</th>
                                        <td>
                                            映像制作、ゲーム制作、アバター制作などにおけるリギング業務全般<br />
                                            {/* <strong>リギングアーティスト</strong><br />
                                            ・スケルトン設定からウェイト調整、コントローラ作成<br /><br />
                                            <strong>テクニカルアーティスト</strong><br />
                                            ・自社ツールの開発・運用、およびクライアントツールの開発支援 */}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>必須スキル/経験</th>
                                        <td>
                                            <strong>中途：</strong>DCCツールを使用したリギング業務2年以上<br />
                                            <strong>新卒：</strong>Mayaの基本操作およびセットアップ習得（授業内容＋任意のセットアップ）

                                        </td>
                                    </tr>
                                    <tr>
                                        <th>歓迎スキル/経験</th>
                                        <td>
                                            ・スクリプト作成経験<br />
                                            ・Unreal Engine / Unity使用経験<br />
                                            ・社会人経験

                                        </td>
                                    </tr>
                                    <tr>
                                        <th>勤務地</th>
                                        <td>完全リモート勤務（フルリモート）</td>
                                    </tr>
                                    <tr>
                                        <th>勤務時間 / 働き方</th>
                                        <td>
                                            フレックスタイム制（休憩時間：60分）<br />
                                            コアタイム 11:30～15:30

                                        </td>
                                    </tr>
                                    <tr>
                                        <th>試用期間</th>
                                        <td>３ヶ月</td>
                                    </tr>
                                    <tr>
                                        <th>その他</th>
                                        <td>社会保険完備（健康保険、厚生年金、雇用保険、労災）</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className={styles.buttonWrapper}>
                                <Link to='/contact' className={styles.applyButton}>応募 / お問い合わせへ</Link>
                            </div>
                        </div>

                        {/* 進行・プロデューサー候補セクション */}
                        <div className={styles.infoCard} id="producers">
                            <div className={styles.cornerTL}></div>
                            <div className={styles.cornerTR}></div>
                            <div className={styles.cornerBL}></div>
                            <div className={styles.cornerBR}></div>

                            <h2 className={styles.cardTitle}>進行・プロデューサー候補</h2>
                            <table className={styles.recruitTable}>
                                <tbody>
                                    <tr>
                                        <th>募集職種</th>
                                        <td>プロデューサー候補・進行スタッフ</td>
                                    </tr>
                                    <tr>
                                        <th>雇用形態</th>
                                        <td>契約社員（正社員登用あり）</td>
                                    </tr>
                                    <tr>
                                        <th>報酬</th>
                                        <td>応募者の能力・経験を考慮し、当社規定により決定いたします。</td>
                                    </tr>
                                    <tr>
                                        <th>賞与</th>
                                        <td>年1回（ただし、業績による）</td>
                                    </tr>
                                    <tr>
                                        <th>昇給</th>
                                        <td>年1回</td>
                                    </tr>
                                    <tr>
                                        <th>業務内容</th>
                                        <td>
                                            ・ゲーム、アニメ、広告案件などにおける制作プロジェクトの進行管理全般<br />
                                            ・クライアントとの要件定義、仕様調整、コミュニケーション窓口業務<br />
                                            ・制作予算、スケジュール、品質の管理<br />
                                            ・営業／採用補佐
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>求めるスキル</th>
                                        <td>
                                            <strong>必須スキル/経験</strong><br />
                                            ・制作進行管理またはプロジェクトマネジメント経験3年以上（CG/映像業界経験者優遇）<br />
                                            ・社内外との円滑なコミュニケーション能力<br />
                                            ・CG制作に関する基礎知識<br /><br />
                                            <strong>歓迎スキル/経験</strong><br />
                                            ・営業経験<br />
                                            ・採用経験<br />
                                            ・CG業界外での社会人経験
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>勤務地</th>
                                        <td>完全リモート勤務（フルリモート）</td>
                                    </tr>
                                    <tr>
                                        <th>勤務時間</th>
                                        <td>フレックスタイム制（休憩時間：60分）<br />
                                            コアタイム 11:30～15:30</td>
                                    </tr>
                                    <tr>
                                        <th>試用期間</th>
                                        <td>3ヶ月間</td>
                                    </tr>
                                    <tr>
                                        <th>その他</th>
                                        <td>社会保険完備（健康保険、厚生年金、雇用保険、労災）</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className={styles.buttonWrapper}>
                                <Link to='/contact' className={styles.applyButton}>応募 / お問い合わせへ</Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default RecruitInfo;
